"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMapmakerAppConfig = void 0;
const MapmakerContext_1 = require("./MapmakerContext");
function useMapmakerAppConfig() {
    return (0, MapmakerContext_1.useMapmakerContext)().appConfig;
}
exports.useMapmakerAppConfig = useMapmakerAppConfig;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJBcHBDb25maWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2xpZW50L01hcG1ha2VyQXBwQ29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdBLHVEQUF1RDtBQThEdkQsU0FBZ0Isb0JBQW9CO0lBQ2xDLE9BQU8sSUFBQSxvQ0FBa0IsR0FBRSxDQUFDLFNBQVMsQ0FBQztBQUN4QyxDQUFDO0FBRkQsb0RBRUMifQ==